/**
 * Simple debounce function
 */
export const debounce = <F extends (...args: any[]) => any>(func: F, waitFor: number) => {
  let timeoutId: NodeJS.Timeout | null = null;

  return (...args: Parameters<F>): void => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => func(...args), waitFor);
  };
};

/**
 * Generates a unique ID with an optional prefix
 * Creates completely independent IDs for all nodes, including duplicated destination nodes
 */
export const generateId = (prefix: string = ''): string => {
  // Generate a random component to ensure uniqueness
  const randomComponent = Math.floor(Math.random() * 100000);
  // Use timestamp for additional uniqueness
  const timestamp = Date.now();
  // Combine prefix, timestamp and random number for a truly unique ID
  return `${prefix}${timestamp}-${randomComponent}`;
};
